import { useState, useEffect, useCallback } from 'react';
import { athletesApi } from '../api/athletes.js';

export function useAthletes() {
  const [athletes, setAthletes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchAthletes = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await athletesApi.list();
      setAthletes(data);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to load athletes');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchAthletes(); }, [fetchAthletes]);

  return { athletes, loading, error, refetch: fetchAthletes };
}
